import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import "./scroll-box.scss";

const ScrollBox = ({ children, className, checkbox, checked }) => {
  const classes = classnames(
    "scroll-box",
    {
      "scroll-box--checked": checked,
    },
    className
  );

  return (
    <div className={classes}>
      <div className="scroll-box__body">
        <div className="scroll-box__body-inner">{children}</div>
      </div>
      <div className="scroll-box__footer">{checkbox}</div>
    </div>
  );
};

ScrollBox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  checkbox: PropTypes.node.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default ScrollBox;
